import api from 'services/api';
import { getCompanyContext } from 'utils/setCompanyContext';

class MetasComerciaisService {
  constructor() {
    // Remover a barra inicial para evitar duplicação
    this.baseURL = 'metas-comerciais';
  }

  /**
   * Buscar metas por empresa e ano
   */
  async buscarMetas(ano, empresa = null) {
    try {
      // Obter empresa do contexto se não fornecida
      if (!empresa) {
        const companyContext = getCompanyContext();
        empresa = companyContext?.companies?.[0]?.name || 'MOV Fibra';
      }
      
      
      const response = await api.post(`${this.baseURL}/buscar`, {
        ano,
        empresa
      });

      
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Erro ao buscar metas:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao buscar metas',
        data: {}
      };
    }
  }

  /**
   * Salvar ou atualizar meta
   */
  async salvarMeta(dados) {
    try {
      // Adicionar empresa se não estiver presente
      if (!dados.empresa) {
        const companyContext = getCompanyContext();
        dados.empresa = companyContext?.companies?.[0]?.name || 'MOV Fibra';
      }
      
      const response = await api.post(`${this.baseURL}/salvar`, dados);

      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('❌ Erro ao salvar meta:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao salvar meta'
      };
    }
  }

  /**
   * Deletar meta
   */
  async deletarMeta(empresa, ano, mes) {
    try {
      // Usar empresa fornecida ou obter do contexto
      if (!empresa) {
        const companyContext = getCompanyContext();
        empresa = companyContext?.companies?.[0]?.name || 'MOV Fibra';
      }
      
      const response = await api.post(`${this.baseURL}/deletar`, {
        empresa,
        ano,
        mes
      });

      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('❌ Erro ao deletar meta:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao deletar meta'
      };
    }
  }

  /**
   * Buscar meta específica
   */
  async buscarMeta(empresa, ano, mes) {
    try {
      // Usar empresa fornecida ou obter do contexto
      if (!empresa) {
        const companyContext = getCompanyContext();
        empresa = companyContext?.companies?.[0]?.name || 'MOV Fibra';
      }
      
      const response = await api.post(`${this.baseURL}/buscar-meta`, {
        empresa,
        ano,
        mes
      });

      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('❌ Erro ao buscar meta específica:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao buscar meta específica'
      };
    }
  }


  /**
   * Buscar vendedores comerciais no N8N para distribuicao de metas
   */
  async listarVendedores(empresa = null) {
    try {
      if (!empresa) {
        const companyContext = getCompanyContext();
        empresa = companyContext?.companies?.[0]?.name || 'MOV Fibra';
      }

      const response = await api.post('/n8n/comercial/lista-vendedores', { empresa });
      const vendedores = response.data?.data?.vendedores || [];

      return {
        success: true,
        data: vendedores
      };
    } catch (error) {
      console.error('❌ Erro ao buscar vendedores comerciais:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao buscar vendedores comerciais',
        data: []
      };
    }
  }

  /**
   * Formatar dados de metas para o frontend
   */
  formatarMetasParaFrontend(metas) {
    const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    const metasFormatadas = {};
    
    meses.forEach(mes => {
      metasFormatadas[mes.toLowerCase()] = {
        vendas: metas[mes]?.vendas || 0,
        receita: metas[mes]?.receita || 0,
        vendedores: metas[mes]?.vendedores || [],
        total_meta_vendedores: metas[mes]?.total_meta_vendedores || 0,
        saldo_disponivel: metas[mes]?.saldo_disponivel || 0
      };
    });

    return metasFormatadas;
  }

  /**
   * Calcular performance baseada em metas
   */
  calcularPerformance(vendasAtuais, metaVendas, receitaAtual, metaReceita) {
    const performanceVendas = metaVendas > 0 ? (vendasAtuais / metaVendas) * 100 : 0;
    const performanceReceita = metaReceita > 0 ? (receitaAtual / metaReceita) * 100 : 0;

    return {
      vendas: Math.round(performanceVendas * 10) / 10,
      receita: Math.round(performanceReceita * 10) / 10
    };
  }
}

const metasComerciaisService = new MetasComerciaisService();
export default metasComerciaisService;




